export const environment = {
  production: false,
  infuraId: 'ccc22181380f4f82a81017265f5a525e',
  initial: {
    loginPath: '/',
    loginStatus: '/status',
  },
  cache: {
    isEncrypt: false,
  },
  secretKey: 'RgUjXn2r5u8x/A?D(G+KbPeShVmYp3s6',
  backendServer: { mainApi: 'https://apis-dev-xrb.monkgames.net' },
  authentication: {
    login: 'v1/auth/wallet-signin',
    refreshToken: 'v1/auth/refreshtoken',
  },
  server: {
    config: 'client/sv-config',
  },
};
